<template>
  <v-container class="h-auto pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="420">
        <v-img class="mx-auto mb-4" :src="LOGO_HEADER" contain />
        <div class="text-h5 text-center mb-8 font-weight-medium">Create Account</div>
      </v-sheet>
    </v-row>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 pa-4" max-width="600">
        <UserEditComponent
          :is-admin="false"
          :is-create="true"
          @profile-saved="handleProfileSaved"></UserEditComponent>
      </v-sheet>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { router } from '@/router/router';
import { LOGO_HEADER } from '@/helpers';
import UserEditComponent from '@/components/user/UserEditComponent.vue';

const handleProfileSaved = async (value: boolean) => {
  if (value) {
    await router.push({ name: 'NewAccountComplete' });
  }
};
</script>
